import { useQuery } from '@tanstack/react-query';
import {
  getBrandsStatsForDomain,
  BrandStatsForDomainResponse,
} from '../../../../../services/monitor/data/sources/MonitorDataSourcesService';
import { ChatType } from '../../../../../types/monitor/ChatType';

const GET_BRANDS_STATS_FOR_DOMAIN = 'brands-stats-for-domain';

export const useGetBrandsStatsForDomain = (
  projectId: number,
  domain: string,
  chatType: ChatType | null,
  from: Date | null,
  to: Date | null,
  monitorPromptIds?: number[],
  filterMonitorTypes?: string[]
) => {
  const queryEnabled = !!projectId && !!domain && !!chatType && !!from && !!to;

  const fromTimestamp = from?.getTime() ?? null;
  const toTimestamp = to?.getTime() ?? null;

  const { data: brandsStats, isLoading } = useQuery<BrandStatsForDomainResponse>({
    queryKey: [GET_BRANDS_STATS_FOR_DOMAIN, projectId, domain, chatType, fromTimestamp, toTimestamp, monitorPromptIds, filterMonitorTypes],
    queryFn: () => getBrandsStatsForDomain(projectId, domain, chatType!, from, to, monitorPromptIds, filterMonitorTypes),
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    enabled: queryEnabled,
  });

  return {
    brandsStats: queryEnabled ? brandsStats ?? null : null,
    isLoading: queryEnabled ? isLoading : false,
  };
};
